import { getTimezoneOffset, formatInTimeZone } from "date-fns-tz";
import { GlossDateInterface } from "@bitwarden/web-vault/app/models/data/shared/gloss-date/gloss-date.interface";
import {
  DateAsISOStringType,
  GlossDateAsObjectType,
} from "@bitwarden/web-vault/app/models/store/types/store.types";
import {
  CONVERT_OTHER_TIMES_TO_LOCAL_TIMEZONE,
  TimeType,
} from "@bitwarden/web-vault/app/models/types/gloss-date.types";

export abstract class GlossDateAbstraction implements GlossDateInterface {
  date: DateAsISOStringType;
  timeZone: string;

  dateString: string;
  offset: number;

  // sets the enriched date property with the information that is available in the class
  getEnrichedDate(defaultTimeType: TimeType = "closing", time?: string): Date {
    let enrichedDate: Date;
    if (CONVERT_OTHER_TIMES_TO_LOCAL_TIMEZONE) {
      enrichedDate = new Date(this.date);
    } else if (time) {
      enrichedDate = new Date(`${this.dateString}T${time}`);
    } else {
      enrichedDate = new Date(this.dateString);
    }
    if (!time) {
      if (defaultTimeType === "opening") {
        enrichedDate.setHours(0, 0, 0, 0); // set to start of the day
      } else {
        enrichedDate.setHours(23, 59, 59); // set to end of the day
      }
    }
    return enrichedDate;
  }

  setFromObject(obj: GlossDateAsObjectType): void {
    this.date = obj.date;
    this.timeZone = obj.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone; // default to local timezone if not provided
    const date = new Date(obj.date);
    this.dateString = formatInTimeZone(date, this.timeZone, "yyyy-MM-dd");
    this.offset = getTimezoneOffset(this.timeZone);
  }

  setFromIsoString(isoDateString: DateAsISOStringType, timeZone?: string): void {
    if (!timeZone) {
      const dateAsObj: GlossDateAsObjectType = {
        date: isoDateString,
        time: null,
        timeZone: null,
        reliableTimeSource: false,
      };
      return this.setFromObject(dateAsObj);
    } else {
      // if the timezone is provided then we need to convert the iso date string to the local timezone
      this.date = isoDateString;
      this.timeZone = timeZone;
      const date = new Date(isoDateString);
      this.dateString = formatInTimeZone(date, timeZone, "yyyy-MM-dd");
      this.offset = getTimezoneOffset(timeZone);
    }
  }

  toGlossDateAsObject(): GlossDateAsObjectType {
    return {
      date: this.date,
      timeZone: this.timeZone,
      time: null,
      reliableTimeSource: false,
    };
  }
}
